import { createContext, useContext, useState, useEffect } from 'react';
import { translations, LANGUAGES } from '../translations';

const LanguageContext = createContext(null);

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'en';
  });
  
  const t = translations[language] || translations.en;
  const dir = LANGUAGES.find(l => l.code === language)?.dir || 'ltr';
  
  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('language', lang);
    document.documentElement.dir = LANGUAGES.find(l => l.code === lang)?.dir || 'ltr';
  };
  
  useEffect(() => {
    document.documentElement.dir = dir;
  }, [dir]);
  
  return (
    <LanguageContext.Provider value={{ language, t, changeLanguage, dir, LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};
